import { useState, useEffect } from 'react';

export const useTreeData = (apiResponse) => {
  const [treeData, setTreeData] = useState({
    nodeMap: new Map(),
    childrenMap: new Map(),
    ancestorMap: new Map(),
    rootNodeId: null,
  });

  useEffect(() => {
    if (!apiResponse) {
      setTreeData({
        nodeMap: new Map(),
        childrenMap: new Map(),
        ancestorMap: new Map(),
        rootNodeId: null,
      });
      return;
    }

    const nodeMap = new Map();
    const childrenMap = new Map();
    const ancestorMap = new Map();

    const addNode = (node) => {
      nodeMap.set(node.node_id, node);
      if (!childrenMap.has(node.node_id)) {
        childrenMap.set(node.node_id, []);
      }
      if (!ancestorMap.has(node.node_id)) {
        ancestorMap.set(node.node_id, []);
      }
    };

    const processNode = (node, parentId = null) => {
      addNode(node);

      if (parentId) {
        // Ensure parent has children array initialized
        if (!childrenMap.has(parentId)) {
          childrenMap.set(parentId, []);
        }

        const siblings = childrenMap.get(parentId);
        if (!siblings.includes(node.node_id)) {
          siblings.push(node.node_id);
        }

        const ancestors = [...(ancestorMap.get(parentId) || []), parentId];
        ancestorMap.set(node.node_id, ancestors);
      }

      if (node.children && node.children.length > 0) {
        node.children.forEach((child) => processNode(child, node.node_id));
      }
    };

    // Add root (me)
    if (apiResponse.me) {
      addNode(apiResponse.me);
      if (apiResponse.downline && apiResponse.downline.length > 0) {
        apiResponse.downline.forEach((child) => processNode(child, apiResponse.me.node_id));
      }
    }

    console.log('useTreeData building:', {
      hasMe: !!apiResponse.me,
      rootNodeId: apiResponse.me?.node_id,
      downlineCount: apiResponse.downline?.length || 0,
      nodeMapSize: nodeMap.size,
      childrenMapSize: childrenMap.size,
    });

    setTreeData({
      nodeMap,
      childrenMap,
      ancestorMap,
      rootNodeId: apiResponse.me?.node_id || null,
    });
  }, [apiResponse]);

  return {
    nodeMap: treeData.nodeMap,
    childrenMap: treeData.childrenMap,
    ancestorMap: treeData.ancestorMap,
    rootNodeId: treeData.rootNodeId,
    getNode: (nodeId) => treeData.nodeMap.get(nodeId),
    getChildren: (nodeId) => treeData.childrenMap.get(nodeId) || [],
    getAncestors: (nodeId) => treeData.ancestorMap.get(nodeId) || [],
  };
};
